import { assignCommonProperties } from '../../util/data/assign-common-properties.js'

import type { ModuleIdType } from '../../types.js'
import type { BusinessObjectIdType } from '../../types.js'
import type { BusinessObjectTypeType } from '../../types.js'

import type { TsCodeType } from '../../types.js'
import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'
import { BusinessObject } from '../business-object.js'
import { BoReference } from '../bo-reference.js'

@jsonClass('RestrictableItemRestriction')
export class RestrictableItemRestriction extends BoReference {
	@jsonProperty(String)
	itemName!: string
	@jsonProperty(String)
	restrictionCode: TsCodeType = ''

	constructor(init?: Partial<RestrictableItemRestriction>) {
		super()
		assignCommonProperties(this, init)
	}

	getFunctionName() {
		return `allow_${this.moduleId}__${this.boId}_${this.itemName?.replaceAll('.', '__')}`
	}

	matches(
		other:
			| {
					moduleId: ModuleIdType
					boType: BusinessObjectTypeType
					boId: BusinessObjectIdType
					itemName: string
			  }
			| BusinessObject,
		itemName?: string,
	) {
		if (other instanceof BusinessObject) {
			return (
				this.moduleId == other.moduleId &&
				this.boType == other.__type &&
				this.boId == other.boId &&
				this.itemName == itemName
			)
		}
		return (
			this.moduleId == other.moduleId &&
			this.boType == other.boType &&
			this.boId == other.boId &&
			this.itemName == (itemName ?? other.itemName)
		)
	}
}
